'use strict';

import Vue from 'vue';

export default (value, currency = null, decimals = 2, locale = null) => {
    let digitsRE = /(\d{3})(?=\d)/g,
        stringified,
        _int,
        _float,
        i,
        sep,
        head,
        sign;
    locale = locale === null ? Vue.i18n.locale() : locale;
    value = parseFloat(value);
    if (!isFinite(value) || (!value && value !== 0)) {
        return '';
    }
    sep = locale === 'de' ? '.' : ',';
    currency = currency === null
        ? locale === 'de' ? '€' : '$'
        : currency;
    stringified = Math.abs(value).toFixed(decimals);
    stringified = locale === 'de' ? stringified.replace('.', ',') : stringified;
    _int = decimals
        ? stringified.slice(0, -1 - decimals)
        : stringified;
    i = _int.length % 3;
    head = i > 0
        ? (_int.slice(0, i) + (_int.length > 3 ? sep : ''))
        : '';
    _float = decimals
        ? stringified.slice(-1 - decimals)
        : '';
    sign = value < 0 ? '-' : '';
    _int = _int.slice(i).replace(digitsRE, `$1${sep}`);
    return locale === 'de'
        ? sign + head + _int + _float + currency
        : sign + currency + head + _int + _float;
};
